import { injectScript, injectStyles } from "./../utilities/DOMUtils";
import Bridge from "./bridge";
import URLRouter from "./../utilities/URLRouter";
import ReaderBrowsingHistoryComponent from "./readerBrowsingHistoryComponent";
import CpStore from "./../stores/cpStore";
import APIManager from "./../utilities/apimanager";
import ContentManager from "./../utilities/contentmanager";

/**
 * This is mixin for appReader classes. It contains methods shared between touch and web
 * appReader class
 * @type {Object}
 */
const appReaderMixin = {
  /**
   * Injects nextgen style and js files (only for clients that have support for nextgen,
   * see client package.json)
   */
  injectNextgenAssets() {
    if (process.env.NEXTGEN) {
      injectStyles(
        `../NextGenViewer/css/style.css?t=${process.env.CLIENT_CONFIG_VERSION}`
      );
      injectScript(
        `../NextGenViewer/NextGenViewer.js?t=${process.env.CLIENT_CONFIG_VERSION}`,
        this._appState.nextgenLoaded.bind(this._appState),
        true
      );
    }
  },

  /**
   * Initialises bridge object (only for clients that have support for nextgen,
   * see client package.json)
   */
  initBridge() {
    if (process.env.NEXTGEN) {
      window.bridge = new Bridge(this._appState, this.pubStore, this.options);
    }
  },

  /**
   * Initialises cp store
   * @param  {array} additionalDownloadTokens additional download tokens
   */
  initCpStore(additionalDownloadTokens) {
    this.cpStore = new CpStore(
      APIManager,
      ContentManager,
      this.contentPackageId,
      additionalDownloadTokens,
      this.options.cpStore
    );
    this.cpStore.on("cpStore:loaded", () => {
      this.onCpLoaded();
    });
    this.cpStore.load();
  },

  /**
   * Initialises browsing history
   */
  initHistory() {
    this.history = new URLRouter();
    this.readerBrowsingHistory = new ReaderBrowsingHistoryComponent(
      this.history,
      this._appState
    );
    this.readerBrowsingHistory.trackHistory();
  },

  /**
   * Setups active publication in app state
   */
  setupPublicationInAppState() {
    this._appState.activePublication = {
      Name: this.pubStore.PublicationToLoad.PublicationName,
      Date: this.pubStore.PublicationToLoad.PublicationDate,
      Id: this.pubStore.PublicationToLoad.PublicationId,
      PublicationType: this.pubStore.PublicationToLoad.PublicationType,
      PublicationFormat: this.pubStore.PublicationToLoad.PublicationTitleFormat,
    };
  },
};

export default appReaderMixin;



// WEBPACK FOOTER //
// ./src/common/components/appReaderMixin.js